import React from 'react';
import { Search, RotateCcw } from 'lucide-react';

const BookingFilters = ({
  searchQuery,
  setSearchQuery,
  selectedDate,
  setSelectedDate,
  statusFilter,
  setStatusFilter,
  activeTab,
  setActiveTab,
  bookingsCount
}) => {
  return (
    <div className="bg-white p-3 rounded-2xl border border-slate-100 shadow-sm mb-4 space-y-3">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex-1 min-w-[200px] relative group">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-[#067978] transition-colors" size={15} />
          <input
            type="text"
            placeholder="Search customers by name, phone or ID..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2 bg-slate-50 border-none rounded-xl text-xs font-semibold text-slate-800 placeholder-slate-400 focus:ring-2 focus:ring-[#067978]/20 outline-none"
          />
        </div>

        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="px-3 py-2 bg-slate-50 border-none rounded-xl text-xs font-semibold text-slate-700 focus:ring-2 focus:ring-[#067978]/20 outline-none cursor-pointer"
        />

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="px-3 py-2 bg-slate-50 border-none rounded-xl text-xs font-semibold text-slate-700 focus:ring-2 focus:ring-[#067978]/20 outline-none cursor-pointer"
        >
          <option value="All">All Statuses</option>
          <option value="Pending">Pending</option>
          <option value="Confirmed">Confirmed</option>
          <option value="Completed">Completed</option>
          <option value="Cancelled">Cancelled</option>
        </select>

        {(searchQuery || selectedDate || statusFilter !== 'All') && (
          <button
            onClick={() => {
              setSearchQuery('');
              setSelectedDate('');
              setStatusFilter('All');
            }}
            className="p-2 text-slate-400 hover:text-rose-600 hover:bg-rose-50 rounded-xl transition-all flex items-center gap-1 text-[11px] font-bold"
            title="Reset Filters"
          >
            <RotateCcw size={14} />
            <span>Reset</span>
          </button>
        )}
      </div>

      <div className="flex gap-2 p-1 bg-slate-100/60 rounded-xl w-fit">
        {['active', 'inactive'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-1.5 rounded-lg font-extrabold text-[10px] transition-all uppercase tracking-wider ${activeTab === tab
              ? 'bg-white text-[#067978] shadow-sm'
              : 'text-slate-500 hover:text-slate-700'
              }`}
          >
            {tab === 'active' ? 'Current Orders' : 'Order History'}
            <span className={`ml-2 px-2 py-0.5 rounded-full text-[10px] ${activeTab === tab ? 'bg-teal-50 text-[#067978]' : 'bg-slate-200 text-slate-500'}`}>
              {bookingsCount[tab]}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BookingFilters;
